module.exports = __webpack_public_path__ + "Assets/Images/onboarding/dashboard-banner/pages-banner-start-creating-action.png";